import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';

import { Context } from '@store/store';
import { getPageToBookmark } from '@utils/getPageToBookmark';
import RemoveBookmarkIcon from '@icons/remove-bookmark-icon';

import { StyledRemoveBookmarkButton } from './remove-bookmark-button.styles';

import { GET_ALL_BOOKMARKS, REMOVE_BOOKMARK } from '@graphql/bookmarks';

const RemoveBookmarkButton = ({ isMobile }) => {
  const [state, dispatch] = useContext(Context);

  const [removeBookmark, { loading, error }] = useMutation(REMOVE_BOOKMARK, {
    update(cache, { data }) {
      const bookmarkToRemove = data?.removeBookmark;
      const existingBookmarks = cache.readQuery({
        query: GET_ALL_BOOKMARKS,
        variables: {
          id: state.bookId,
        },
      });

      if (data.removeBookmark) {
        cache.writeQuery({
          query: GET_ALL_BOOKMARKS,
          data: {
            book: {
              bookmarks: existingBookmarks?.book?.bookmarks.filter(
                b => b !== bookmarkToRemove,
              ),
            },
          },
          variables: {
            id: state.bookId,
          },
        });
      }
    },
    onCompleted: () => {
      dispatch({ type: 'SET_IS_BOOKMARKED', payload: false });
      dispatch({ type: 'SHOW_BOOKMARK_MODAL', payload: true });
    },
  });

  const bookmarkRemove = () => {
    let bookmarkRemovePage = [state.currentPage]
    if (!state.isSinglePageMode) {
      bookmarkRemovePage = state.currentPage >= state.pagesCount
      ? [state.currentPage - 1]
      : [state.currentPage - 1, state.currentPage];
    }
    
    bookmarkRemovePage.forEach(page => {
      removeBookmark({
        variables: {
          bookId: state.bookId,
          page: page,
        },
      });
    })
    
  }

  return (
    <StyledRemoveBookmarkButton
      onClick={bookmarkRemove}
      data-ignore-click-outside="bookmarks-sidebar"
    >
      <RemoveBookmarkIcon
        width={isMobile ? 20 : 28}
        height={isMobile ? 20 : 28}
      />
    </StyledRemoveBookmarkButton>
  );
};

export default RemoveBookmarkButton;
